import type { Node as PMNode } from '@atlaskit/editor-prosemirror/model';

import type { API } from '../../aiStreamingOrchestratorPluginType';

export function getPmDoc(api: API | undefined): PMNode | undefined {
	let doc: PMNode | undefined;
	// Quick and dirty way to get the doc
	api?.core.actions.execute(({ tr }) => {
		doc = tr.doc;
		return null;
	});
	return doc;
}
